import { Company } from './../../model/company';
import { Component, OnInit, OnChanges, Input, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import * as $ from 'jquery';
import { ReportService } from '../../service/report.service';
import { Report } from '../../model/report.model';
import { ToastService } from '../../service/toast.service';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';

@Component({
  selector: 'app-signatory',
  templateUrl: './signatory.component.html',
  styleUrls: ['./signatory.component.less']
})
export class SignatoryComponent implements OnInit, OnChanges {
  signatoryForm: FormGroup;
  @Input() reportId: string;
  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  drawNewSignature : boolean;
  isdrawn : boolean;
  timerEvent: NodeJS.Timer;
  private report: any;

  constructor(private readonly _reportService: ReportService,
    private readonly _toastService : ToastService) {
      this.isdrawn =  false;
    this.signatoryForm = new FormGroup({
      firstName: new FormControl(''),
      lastName: new FormControl(''),
      companyName: new FormControl(''),
      signatoryLicense: new FormControl(''),
      email: new FormControl(''),
      phone: new FormControl('')});
  }

  ngOnInit() {
       }

   sendData(){
    clearTimeout(this.timerEvent);
    this.timerEvent = setTimeout(() => {
      this._toastService.toastOpen(true);
      this._reportService.save(this.report)
        .then((savedReport: Report) => {
          this.report = savedReport;
          this._toastService.toastOpen(false);
      });
    }, 800);
   }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.reportId.currentValue) {
      this._reportService.get(changes.reportId.currentValue)
        .then(report => {
          this.report = report;
            this.signatoryForm.setValue({
              email: this.report.signatoryEmail || '',
              firstName: this.report.signatoryFirstName || '',
              lastName: this.report.signatoryLastName || '',
              companyName: this.report.signatoryCompanyName|| '',
              signatoryLicense: this.report.signatoryLicense|| '',
              phone: this.report.signatoryPhone || ''
             });
             this.signatoryForm.valueChanges.subscribe(newValues => {
              this.report.signatoryEmail = newValues.email;
              this.report.signatoryFirstName = newValues.firstName;
              this.report.signatoryLastName = newValues.lastName;
              this.report.signatoryCompanyName = newValues.companyName,
              this.report.signatoryLicense = newValues.signatoryLicense,
              this.report.signatoryPhone = newValues.phone;
              this.sendData();
            });
          if (this.report && this.report.signatorySignature)
            this.drawNewSignature = true;
          else
            this.drawNewSignature = false;
        });
    }
  }

    signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': 0.5,
    'maxWidth': 2.5,
    'dotSize':0.5,
    'canvasWidth': 264,
    'canvasHeight': 200
  };

  delSignature() {
    this.drawNewSignature = false;
    this.isdrawn = false;

    this.signaturePad.clear(); 
    this.drawComplete()
  }
  drawComplete() {
    const blanksignatureChrome = "data:image/png;base64,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"
    const blanckSignatureFirefox = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQgAAADICAYAAAAUaX//AAAA5ElEQVR4nO3BMQEAAADCoPVPbQo/oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIC3ATn1AAF3GBjqAAAAAElFTkSuQmCC"
    this._toastService.toastOpen(true);
    if ( this.signaturePad.toDataURL() !== blanksignatureChrome 
    && this.signaturePad.toDataURL() !== blanckSignatureFirefox){
    console.log(this.signaturePad.toDataURL());
      this._reportService.saveSignature(this.report, this.signaturePad.toDataURL())
      .then(data => {      this._toastService.toastOpen(false);
        this.drawNewSignature = true;
        console.log("image saved");
      })
    } else {
      this._reportService.saveSignature(this.report, null, true)
      .then(data => {      this._toastService.toastOpen(false);
      })
    }
  }
 
  drawStart() {
    this.isdrawn = true;
    this.drawNewSignature = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/element/signatory/signatory.component.ts